export const OrderActionTypes = {
  ADD: {
    ORDER_PENDING: "ADD_ORDER_PENDING",
    ORDER_SUCCESS: "ADD_ORDER_SUCCESS",
    ORDER_ERROR: "ADD_ORDER_ERROR",
  },
  SAVE: "SAVE_ORDER",
  RESET: {
    ORDER_ADD: "RESET_ORDER_ADD",
  },
};
